import { HomeMemberProfilePage } from './HomeMemberProfilePage';
export default HomeMemberProfilePage;
